import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import {useI18n} from "vue3-i18n";
import {notifyError, notifySuccess} from "@/notify";
import {useBookService} from "@/inversify.config";
import {useRouter} from "vue-router";
import {Book} from "@/types/entities";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import BookForm from "@/components/books/BookForm.vue";
import Card from "@/components/layout/Card.vue";
import {ref} from "vue";
import {IEditBookRequest} from "@/types/requests/editBookRequest";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminEditBookForm',
  props: {
    id: {}
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props;

const {t} = useI18n()
const router = useRouter();
const bookService = useBookService();

const book = ref<Book>((
  ([__temp,__restore] = _withAsyncContext(() => bookService.getBook(props.id))),
  __temp = await __temp,
  __restore(),
  __temp
));

async function handleSubmit(book : Book) {
    let succeededOrNotResponse = await bookService.editBook(book as IEditBookRequest)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.book.edit.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.book.edit');
        if (errorMessages.length == 0)
            notifyError(t('validation.book.edit.errorOccurred'))
        else
            notifyError(errorMessages[0])
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.books.edit.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.admin.children.books.edit.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(BookForm, {
          book: book.value,
          onFormSubmit: handleSubmit
        }, null, 8, ["book"])
      ]),
      _: 1
    })
  ]))
}
}

})